import classNames from 'classnames';
import React from 'react';
import PropTypes from 'prop-types';
import Label from '../../components/foundations/Label';
import QuestionMark from '../../components/widgets/QuestionMark';
import css from './FormField.css';

const FormField = ({
    labelKey,
    required,
    subtitleKey,
    labelTooltipKey,
    children,
    horizontal = false,
    fullWidth = false,
    className = '',
    anchor,
}) => (
    <div
        className={classNames(css.field, { [css.horizontal]: horizontal }, className)}
        data-error-anchor={anchor || undefined}
    >
        <div className={css.labelSection}>
            <div className={css.labelRow}>
                <Label text={labelKey} type="fieldLabel" className={css.label} />
                {required && <span className={css.required}>*</span>}
                {labelTooltipKey && <QuestionMark message={labelTooltipKey} />}
            </div>
            {subtitleKey && <Label text={subtitleKey} type="p" className={css.subtitle} />}
        </div>
        <div className={classNames(css.input, { [css.fullWidth]: fullWidth })}>{children}</div>
    </div>
);

FormField.propTypes = {
    labelKey: PropTypes.string.isRequired,
    required: PropTypes.bool,
    subtitleKey: PropTypes.string,
    labelTooltipKey: PropTypes.string,
    children: PropTypes.node,
    horizontal: PropTypes.bool,
    fullWidth: PropTypes.bool,
    className: PropTypes.string,
    anchor: PropTypes.string,
};

export default FormField;
